<template>
  <v-card>
    <v-card-title class="display-2 mb-4">Upcoming Events and Challenges</v-card-title>

    <div v-if="profile && profile.events && profile.events.length > 0">
      <v-card-title class="subtitle mb-0 pb-0">My Events</v-card-title>
      <EventGrid :items="profile.events" class="mx-4 mb-4 mt-4"></EventGrid>
      <v-card-title class="subtitle mt-6 mb-0 pb-0">Other upcoming events</v-card-title>
    </div>      

    <v-alert prominent tile type="info">
      Not seeing the challenge you're looking for? Most challenges are private and only registered users can participate in them. Please contact your race organizer directly to get a link to your virtual challenge.
    </v-alert>

    <EventGrid :items="events" class="mx-4 mb-4 mt-4"></EventGrid>
    <br/>



    <v-divider/>
    <v-card-title v-if="tenant.showFeatures">Your virtual event on sodisp?</v-card-title>
    <v-card-text v-if="tenant.showFeatures">
      <p>Want to feature your (virtual) event or challenge on sodisp? We support a wide range of features to build unique virtual experiences.</p>
      <ul class="mb-4">
        <li>One click join for participants using Strava or Garmin</li>
        <li>Badges and virtual course maps</li>
        <li>Individual and team rankings</li>
        <li>3 different challenge modes: best result, total distance or total elevation</li>
        <li>Focus on social distancing to assure participants, sponsors and government bodies</li>
        <li><router-link to="/contact">Free for your first event, simple and fair pricing thereafter</router-link></li>
        <li><router-link :to="{name: 'virtualEvent' }">More about a Virtual Event</router-link></li>
      </ul>
      <v-btn color="accent" class="mr-4" :to="{ name: 'eventmanagerCreate'}">Create event</v-btn>
      <v-btn outlined color="accent" class="mr-4" :to="{name: 'features' }">Features</v-btn>
      <v-btn outlined color="accent" :to="{name: 'contact' }">Contact us</v-btn>
    </v-card-text>
  </v-card>
</template>



<script>
import { mapGetters } from "vuex";
import { EventBus } from '@/plugins/eventbus.js';
import profileService from "@/services/profileService";
import eventService from "@/services/eventService";
import EventGrid from "@/components/EventGrid.vue";
import tenants from '@/data/tenants.config'
const tenant = tenants.current();

export default {
  name: "Profile",
  components: {
    EventGrid,
  },
  props: {
  },
  data() {
    return {
      tenant: tenant,
      events: null,
      profile: null,
    };
  },
  async mounted() {
    var response = await eventService.upcoming();
    this.events = response.data.data;

    await this.getProfile();

    //this.$vuetify.theme.custom = true;
    
    EventBus.$on('login-state-change', async user => {
      await this.getProfile();
    });

  },
  methods: {
    
    async getProfile() {
      if (this.user) {
        var response = await profileService.get(/*full:*/true);
        this.profile = response.data;
        console.log('Profile loaded');
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },

};
</script>
<style lang="scss">
</style>

